module.exports = __webpack_public_path__ + "static/img/command-kong-logo1.dc74497f.png";